import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

_instituto: string;
_AreaInstitucional: string
_copyrigth: string;
_creadaPor: string;


constructor() {    
 }

 /**
  * Cargar los datos del autor del sitio
  */
ngOnInit() {
  this._instituto = 'Instituto Secundario para Adultos San Jeronimo';
  this._copyrigth = '2020 Copyright';
  this._AreaInstitucional = 'Área Informatica';  
  this._creadaPor = 'Ing. Bono David';
}


}
